import { render, staticRenderFns } from "./EmploymentDetails.vue?vue&type=template&id=8ac1dc72&"
import script from "./EmploymentDetails.vue?vue&type=script&lang=js&"
export * from "./EmploymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports